// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + {"12":"profiler","777":"recorder"}[chunkId] + "." + {"12":"a789c0a305559a26","777":"77f96987c4cf624a"}[chunkId] + ".js";
};